<script setup lang="ts">
  // Native clone of the desktop wizard's StepConnection: same cards, but
  // USB/BT descriptions use native wording (tablet/dispositivo, not "esta
  // computadora").
  import PosUiIcon from '@/components/pos-v2/ui/PosUiIcon.vue';

  export type TNativeWizardConnection = 'usb' | 'network' | 'bluetooth';

  const emit = defineEmits<{
    (e: 'select', connection: TNativeWizardConnection): void;
  }>();

  const options: {
    value: TNativeWizardConnection;
    icon: string;
    titleKey: string;
    descKey: string;
  }[] = [
    {
      value: 'usb',
      icon: 'usb',
      titleKey: 'printingV2.connUsbTitle',
      descKey: 'printingV2.nativeConnUsbDesc',
    },
    {
      value: 'network',
      icon: 'wifi',
      titleKey: 'printingV2.connNetTitle',
      descKey: 'printingV2.connNetDesc',
    },
    {
      value: 'bluetooth',
      icon: 'bluetooth',
      titleKey: 'printingV2.connBtTitle',
      descKey: 'printingV2.nativeConnBtDesc',
    },
  ];
</script>

<template>
  <div class="native-step-connection">
    <button
      v-for="option in options"
      :key="option.value"
      type="button"
      class="connection-card"
      @click="emit('select', option.value)"
    >
      <div class="connection-card-icon">
        <PosUiIcon :name="option.icon" :size="26" />
      </div>
      <div class="connection-card-text">
        <div class="connection-card-title">{{ $t(option.titleKey) }}</div>
        <div class="connection-card-desc">{{ $t(option.descKey) }}</div>
      </div>
      <PosUiIcon name="chevron-right" class="connection-card-chevron" />
    </button>
  </div>
</template>

<style scoped lang="scss">
  .native-step-connection {
    @apply tw-flex tw-flex-col tw-gap-3;

    .connection-card {
      @apply tw-flex tw-items-center tw-gap-4 tw-rounded-xl tw-border tw-border-neutral-200 tw-bg-white tw-px-4 tw-py-4 tw-text-left tw-transition-colors hover:tw-border-orange-300 hover:tw-bg-orange-50/40;

      .connection-card-icon {
        @apply tw-flex tw-h-12 tw-w-12 tw-flex-none tw-items-center tw-justify-center tw-rounded-xl tw-bg-neutral-100 tw-text-neutral-500;
      }

      .connection-card-text {
        @apply tw-min-w-0 tw-flex-1;

        .connection-card-title {
          @apply tw-text-sm tw-font-semibold tw-text-neutral-900;
        }

        .connection-card-desc {
          @apply tw-mt-0.5 tw-text-xs tw-text-neutral-500;
        }
      }

      .connection-card-chevron {
        @apply tw-flex-none tw-text-xl tw-text-neutral-300;
      }
    }
  }
</style>
